import merge from 'lodash/merge';
import config from '../../config';
import fetch, { toQueryString } from '../fetch';
import RestEntityAPI from './restEntityAPI';

const MediaAPI = () => {
  const parentAPI = RestEntityAPI({
    entityName: 'media',
    endpoint: () => `${config.apiUrl}/v2/media`,
  });

  const createEntity = async (data, query) => {
    try {
      const response = await fetch(`${config.apiUrl}/v2/media${toQueryString(query)}`, {
        method: 'POST',
        body: data,
        formData: true,
      });
      return response;
    } catch (error) {
      throw error;
    }
  };

  return merge({}, { ...parentAPI }, { createEntity });
};

export default MediaAPI();
